import { useEffect } from 'react';
import useIsWebView from '@hooks/useIsWebview';
export function useDisableClickWebview(options) {
  var _options$className;
  var isWebview = useIsWebView();
  var className = (_options$className = options === null || options === void 0 ? void 0 : options.className) !== null && _options$className !== void 0 ? _options$className : 'disableOnWebView';
  useEffect(function () {
    if (!isWebview || typeof document === 'undefined') return;
    var handler = function handler(event) {
      var _event$target;
      var target = (_event$target = event.target) === null || _event$target === void 0 ? void 0 : _event$target.closest("a.".concat(className));
      if (target) {
        event.preventDefault();
        event.stopPropagation();
      }
    };
    document.body.addEventListener('click', handler, true);
    return function () {
      document.body.removeEventListener('click', handler, true);
    };
  }, [isWebview, className]);
}
export default useDisableClickWebview;